<template>
  <div>
    <!-- <van-sticky>
      <van-nav-bar title="等级表" left-text="返回" left-arrow @click-left="onClickLeft"/>
    </van-sticky> -->
    <div class="box">
      <div class="userGrade">
        <div class="title">
          <div class="grade">
            <p>{{ this.rank }}</p>
            <van-tag plain type="primary">当前等级</van-tag>
          </div>
          <div class="img">
            <van-image :src="url">
              <template v-slot:error>加载失败</template>
            </van-image>
          </div>
        </div>
        <div class="jdt">
          <van-progress :percentage="70" stroke-width="5" />
        </div>
      </div>
      <h3>会员等级对照:</h3>
      <ve-table :row-style-option="rowStyleOption" :columns="columns" :table-data="list" :border-x="true" :border-y="true" :cell-style-option="cellStyleOption" />
    </div>
    <div class="zwf"></div>
  </div>
</template>

<script>
import { cardGrade, rankSet } from '@/api/user.js'
export default {
  components: {},
  props: {},
  data () {
    return {
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {
          if (rowIndex === this.grade - 1) {
            return 'table-body-cell-class1'
          }
        }
      },
      rowStyleOption: {
        stripe: true
      },
      columns: [
        // { field: 'agent_rank', key: 'a', title: '用户等级', align: 'center' },
        { field: 'user_rank', key: 'b', title: '代理等级', align: 'center' },
        { field: 'startnum', key: 'c', title: '卡数开始', align: 'center' },
        { field: 'endnum', key: 'd', title: '卡数截至', align: 'center' }
      ],
      grade: '',
      rank: '',
      list: [],
      url: ''
    }
  },
  watch: {},
  computed: {},
  methods: {
    // onClickLeft () { this.$router.go(-1) },
    // 等级
    async Rank () {
      const { data: res } = await cardGrade({ token: this.$store.state.token, userId: this.$store.state.userID.split('a')[0] })
      this.rank = res.rank
      if (this.rank === 'V1') {
        this.grade = '1'
      } else if (res.rank === 'V2') {
        this.grade = '2'
      } else if (res.rank === 'V3') {
        this.grade = '3'
      } else if (res.rank === 'V4') {
        this.grade = '4'
      } else if (res.rank === 'V5') {
        this.grade = '5'
      } else if (res.rank === 'V6') {
        this.grade = '6'
      } else if (res.rank === 'V7') {
        this.grade = '7'
      }
      if (res.msg && res.msg.indexOf('请重新登录') !== -1) {
        this.$router.push('/login')
        this.$toast('请重新登录')
      }
    },
    // 等级表
    async rankSet () {
      const { data: res } = await rankSet({ token: this.$store.state.token, userId: this.$store.state.userID.split('a')[0] })
      if (res.code !== 1) {
        this.list = res.extend.rows
      }
      if (res.msg.indexOf('请重新登录') !== -1) {
        this.$router.push('/login')
        this.$toast('请重新登录')
      }
    }
  },
  beforeCreate () {},
  created () {
    this.Rank()
    this.rankSet()
    this.url = this.$store.state.accessToken ? this.$store.state.accessToken.headImgUrl : require('../../../../assets/user.png')
  },
  mounted () {}
}
</script>

<style scoped lang='less'>
  .box {
    padding: 30px;
    .userGrade {
      height: 380px;
      width: 100%;
      background-image: linear-gradient(5deg, #f9f7f7 0%, #276ace 100%);
      margin-bottom: 30px;
      display: flex;
      flex-direction: column;
      border-radius: 25px;
      color: #fff;
      .title {
        flex: 1;
        display: flex;
        padding: 25px 25px 0;
        position: relative;
        align-items: center;
        .grade {
          flex: 1;
          display: flex;
          align-items: flex-start;
          p {
            margin-left: 5%;
            font-size: 80px;
          }
          span{
            margin-left: 15%;
            top: 30px;
          }
        }
        .img {
          top: 8%;
          width: 250px;
          position: relative;
          height: 100%;
          img {
            position: absolute;
            width: 80%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      .jdt {
        width: 100%;
        padding: 25px;
        /deep/.van-progress__pivot {
          display: none;
        }
      }
    }
    h3 {
      font-size: 30px;
      font-weight: 700;
      margin-bottom: 15px;
    }
  }
  /deep/.ve-table-header-th,
  /deep/.ve-table-body-td{
    height: 100px!important;
    font-size: 25px!important;
  }
  /deep/.ve-table {
    border-bottom: 1px solid #eeeeee;
    border-top: 1px solid #eeeeee;
  }
  /deep/.table-body-cell-class1 {
    background: #91d5ff !important;
    color: #fff !important;
  }
</style>
